module.exports = __webpack_public_path__ + "static/media/accMgr.0da673ce.svg";